import { Home } from "../Home";
import { WhoWeAre } from "../WhoWeAre";
import { Tratament } from "../Tratament";
import { Installation } from "../Installations";
import { Depositions } from "../Depositions";
import { Donations } from "../Donations";
import { Prevention } from "../Prevention";
import { Location } from "../Location";

export const LandingPage = () => {
  return (
    <div>
      <section id="home">
        <Home />
      </section>
      <section id="quemSomos">
        <WhoWeAre />
      </section>
      <section id="tratamento">
        <Tratament />
      </section>
      <section id="instalacao">
        <Installation />
      </section>
      <section id="depoimentos">
        <Depositions />
      </section>
      <section id="prevencao">
        <Prevention />
      </section>
      <section id="localizacao">
        <Location />
      </section>
      <section id="doacoes">
        <Donations />
      </section>
    </div>
  );
};
